import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {cadastrarPreco} from '../../actions/preco/cadastrarPreco'
import buscarPrecos from '../../actions/preco/buscarPrecos';
import alterarPreco from '../../actions/preco/alterarPreco'
import {renderFieldSelect, renderTextArea2, requiredSelect} from '../../util/inputs';
import bloquearPoltrona from '../../actions/poltrona/bloquearPoltrona';
import buscarMapaVeiculoItinerarioBloqueioPoltrona
  from '../../actions/itinerario/buscarMapaVeiculoItinerarioBloqueioPoltrona';
import $ from 'jquery';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalCadastrarBloqueioPoltrona extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  fecharModal () {
    $('#modalCadastrarBloqueioPoltrona')
      .modal('hide');
    $('#modalCadastrarBloqueioPoltrona')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.props.reset('formularioCadastroBloqueioPoltrona');
  }

  assentosSelecionados(){
    let assentosSelicionado = []
   this.props.mapaVeiculoItinerario.forEach( fileira => {
     fileira.assentos.forEach(assento =>{
       if(assento.selecionado){
         assentosSelicionado.push(assento)
       }
     })

   })
    return assentosSelicionado
  }

  idsPoltranasSelecionadas(){
    let ids = []
    this.props.mapaVeiculoItinerario.forEach( fileira => {
      fileira.assentos.forEach(assento =>{
        if(assento.selecionado){
          ids.push(assento.poltrona.id)
        }
      })
    })
    return ids
  }


  submit (values) {
    const parametros = {
      poltronaIds: this.idsPoltranasSelecionadas(),
      trechoOrigemId: values.trechoOrigem.value,
      trechoDestinoId: values.trechoDestino.value,
      empresaId: this.props.empresaSelecionada.id,
      motivo: values.motivo
    };

    this.props.bloquearPoltrona(parametros)
      .then(() => {
          showSuccessMsg('Poltrona bloqueada com sucesso');
          this.props.buscarMapaVeiculoItinerarioBloqueioPoltrona(this.props.empresaSelecionada.id, this.props.itinerarioSelecionado.id);
          this.fecharModal();
      })
  }

  exibirNumeroAssentoSelecionado () {
    const assentos = this.assentosSelecionados();
    if (assentos && assentos.length > 0) {
      return assentos.map(assento => (
        <span className="vx-bloq-seat-badge" key={assento.poltrona.id}>
          {assento.poltrona.numero}
        </span>
      ));
    }
    return <span className="vx-bloq-no-seats">Nenhuma poltrona selecionada</span>;
  }

  render () {
    const { handleSubmit, submitting, invalid, pristine } = this.props;
    return (
      <div className="modal fade show" id='modalCadastrarBloqueioPoltrona' role='dialog'
        aria-labelledby='modalCadastrarBloqueioPoltrona' aria-hidden='true' data-backdrop='static'>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content vx-modal-content">

            <div className="modal-header vx-modal-header">
              <div className="vx-modal-header-left">
                <i className="material-icons">block</i>
                <h5 className="vx-modal-title">Cadastrar Bloqueio de Poltrona</h5>
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                onClick={() => this.props.reset('formularioCadastroBloqueioPoltrona')}>
                <i className="material-icons">close</i>
              </button>
            </div>

            <div className="modal-body vx-modal-body">

              <div className="vx-modal-section">
                <div className="vx-modal-section-title">
                  <i className="material-icons">event_seat</i>
                  Poltronas Selecionadas
                </div>
                <div className="vx-bloq-seats-row">
                  {this.exibirNumeroAssentoSelecionado()}
                </div>
              </div>

              <form onSubmit={handleSubmit(this.submit)}>

                <div className="vx-modal-section mt-3">
                  <div className="vx-modal-section-title">
                    <i className="material-icons">alt_route</i>
                    Trecho do Bloqueio
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <Field name='trechoOrigem'
                        options={this.props.itinerarioSelecionado.rotaDto.trechosDto.map(elemento => ({
                          descricao: elemento.cidadeDestino.nome,
                          nome: elemento.id
                        }))}
                        component={renderFieldSelect}
                        label='Trecho de Origem'
                        placeholder='Selecione...'
                        validate={requiredSelect}/>
                    </div>
                    {this.props.trechoOrigem && (
                      <div className="col-12 col-md-6">
                        <Field name='trechoDestino'
                          options={this.props.itinerarioSelecionado.rotaDto.trechosDto.map(elemento => ({
                            descricao: elemento.cidadeDestino.nome,
                            nome: elemento.id
                          }))}
                          component={renderFieldSelect}
                          label='Trecho de Destino'
                          placeholder='Selecione...'
                          validate={requiredSelect}/>
                      </div>
                    )}
                  </div>
                </div>

                <div className="vx-modal-section mt-3">
                  <div className="vx-modal-section-title">
                    <i className="material-icons">notes</i>
                    Motivo do Bloqueio
                  </div>
                  <Field name='motivo' css="form-control" component={renderTextArea2}
                    max={2000} className="form-control" label="Descreva o motivo"/>
                </div>

                <div className="modal-footer vx-modal-footer mt-3">
                  <button type="button" className="vx-btn-modal-cancel" data-dismiss="modal"
                    onClick={() => this.props.reset('formularioCadastroBloqueioPoltrona')}>
                    Cancelar
                  </button>
                  <button type="submit" disabled={invalid || submitting || pristine}
                    className="vx-btn-modal-save">
                    <i className="material-icons">block</i>
                    Bloquear Poltrona
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const selector = formValueSelector('formularioCadastroBloqueioPoltrona');

export function mapStateToProps (state) {
  return {
    trechoOrigem: selector(state, 'trechoOrigem'),
    trechoDestino: selector(state, 'trechoDestino'),
    empresaSelecionada: state.empresaSelecionada,
    itinerarioSelecionado: state.itinerarioSelecionado,
    mapaVeiculoItinerario: state.mapaVeiculoItinerario,
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarPreco,
    buscarPrecos,
    alterarPreco,
    bloquearPoltrona,
    buscarMapaVeiculoItinerarioBloqueioPoltrona
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioCadastroBloqueioPoltrona',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalCadastrarBloqueioPoltrona));
